// src/shared/components/NotFound.tsx
import { Link } from '@tanstack/react-router';

export const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-4xl font-bold">404 - Page Not Found</h1>
      <p className="mt-4 text-muted-foreground">
        The route you are looking for does not exist.
      </p>
      {/* The button says Dashboard, so it goes to the dashboard. It linked to
          /strategies, a leftover from when that was the landing page. */}
      <Link
        to="/dashboard"
        className="mt-6 px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90"
      >
        Go back to Dashboard
      </Link>
    </div>
  );
};
